import { types as actionTypes } from './listsActions';
import { Action } from '../../../types';
import { WaiverWorkItemsListType } from '../../../../types/waiverWorkItem';

const initialState: WaiverWorkItemsListType = 'ACTIVE_WORK_ITEMS';

export default function reducer(
  state: WaiverWorkItemsListType = initialState,
  action: Action<WaiverWorkItemsListType>,
): WaiverWorkItemsListType {
  if (!action.response) {
    return state;
  }
  switch (action.type) {
    case actionTypes.LOAD_SUCCESS:
      return action.response;
    default:
      return state;
  }
}
